import { Box, CircularProgress } from "@mui/material";
import { apiRequest } from "api-client";
import { useEffect } from "react";

export default function YoutubeCallback() {
  const params = new URLSearchParams(window.location.search);
  const code = params.get("code");
  useEffect(() => {
    apiRequest.get(
      `/youtube/oauth2callback?code=${code}`,
    )
    .then((data) => {
      window.close();
    })
    .catch((error) => {
      alert("Error: " + error);
    });
  }, [code]);
  // const form = new FormData();
  return (
    <Box display="flex" flexDirection="column" alignItems="center" justifyContent="center" height="100vh">
      <CircularProgress />
    </Box>
  );
}